import React from "react";
import PropTypes from 'prop-types';
import "./statusBarSkeleton.scss";
function URStatusbarSkeleton(props: any) {
  let {className } = props;
  return (
    <>
      <div className={className}></div>
    </>

  );
}

export {
  URStatusbarSkeleton
};

URStatusbarSkeleton.propTypes = {
  className: PropTypes.any,
  profileInfo: PropTypes.any
};